import { render, staticRenderFns } from "./Historia.vue?vue&type=template&id=bf0a4800&scoped=true&"
import script from "./Historia.vue?vue&type=script&lang=js&"
export * from "./Historia.vue?vue&type=script&lang=js&"
import style0 from "./Historia.vue?vue&type=style&index=0&id=bf0a4800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0a4800",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
